// Multivariate Dependencies
import React, { useState, useEffect } from 'react';
// Components
import { Icon } from '../../Icon';
// Utils
import { getUnixTime } from 'ezyvet-fe-helpers';
import { convertSecondsToStopwatchFormat } from '../utils/convertSecondsToStopwatchFormat';
// Types
import { StopwatchLabels, StopwatchStates, REFRESH_INTERVAL } from '../types/StopwatchProps';
export var StopwatchStructure = function (_a) {
    var className = _a.className, state = _a.state, startTime = _a.startTime, onClick = _a.onClick;
    var _b = useState(), timeLabelToShow = _b[0], setTimeLabelToShow = _b[1];
    useEffect(function () {
        // Updating the state here rather than in the useState as we want to see the elapsed time immediately
        setTimeLabelToShow(convertSecondsToStopwatchFormat(getUnixTime(new Date()) - startTime));
        var updateTimeLabel = setInterval(function () {
            setTimeLabelToShow(convertSecondsToStopwatchFormat(getUnixTime(new Date()) - startTime));
        }, REFRESH_INTERVAL);
        return function () {
            window.clearInterval(updateTimeLabel);
        };
    }, [startTime]);
    return (React.createElement("button", { className: className + " " + state, "aria-label": StopwatchLabels[state], onClick: onClick, disabled: state === StopwatchStates.LOADING },
        React.createElement(Icon, { width: '18px', height: '18px', ariaLabel: '', name: 'Stopwatch' }),
        timeLabelToShow));
};
//# sourceMappingURL=StopwatchStructure.js.map